/* unplugin-vue-components disabled */import script from "./ColumnTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColumnTabs.vue?vue&type=script&lang=ts&setup=true"

import "./ColumnTabs.vue?vue&type=style&index=0&id=550e6729&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-550e6729"]])

export default __exports__